import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Calender
import Calender from "../Pages/Calender";

// Import E-mail
import Inbox from "../Pages/E-mail/Inbox";
import ReadEmail from "../Pages/E-mail/ReadEmail";
import EmailCompose from "../Pages/E-mail/EmailCompose";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/UserProfile.js";

// Import Authentication Inner Pages
import Login1 from "../Pages/AuthenticationPages/Login";
import Register1 from "../Pages/AuthenticationPages/Register";
import RecoverPassword from "../Pages/AuthenticationPages/RecoverPassword";
import LockScreen from "../Pages/AuthenticationPages/LockScreen";

// Import Utility Pages
import StarterPage from "../Pages/Utility/Starter-Page";
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";
import TimeLine from "../Pages/Utility/TimeLine-Page";
import FAQs from "../Pages/Utility/FAQs-Page";
import Pricing from "../Pages/Utility/Pricing-Page";
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

// Import UIElement Pages
import UiAlerts from "../Pages/UiElements/UiAlerts";
import UiBadge from "../Pages/UiElements/UiBadge";
import UiBreadcrumb from "../Pages/UiElements/UiBreadcrumb";
import UiButtons from "../Pages/UiElements/UiButtons";
import UiCards from "../Pages/UiElements/UiCards";
import UiCarousel from "../Pages/UiElements/UiCarousel";
import UiDropdown from "../Pages/UiElements/UiDropdowns";
import UiGrid from "../Pages/UiElements/UiGrid";
import UiImages from "../Pages/UiElements/UiImages";
import UiLightbox from "../Pages/UiElements/UiLightbox";
import UiModals from "../Pages/UiElements/UiModals";
import UiOffcanvas from "../Pages/UiElements/UiOffcanvas";
import UiRangeSlider from "../Pages/UiElements/UiRangeSlider";
import UiSessionTimeout from "../Pages/UiElements/UiSessionTimeout";
import UiPagination from "../Pages/UiElements/UiPagination";
import UiProgressBars from "../Pages/UiElements/UiProgressBars";
import UiPlaceholders from "../Pages/UiElements/UiPlaceholders";
import UiTabs from "../Pages/UiElements/UiTabs&Accordions";
import UiTypography from "../Pages/UiElements/UiTypography";
import UiToasts from "../Pages/UiElements/UiToasts";
import UiVideo from "../Pages/UiElements/UiVideo";
import UiPopovers from "../Pages/UiElements/UiPopovers&Tooltips";
import UiRating from "../Pages/UiElements/UiRating";

// Import Forms
import FormEditors from "../Pages/Forms/FormEditors";
import FormUpload from "../Pages/Forms/FormUpload";
import FormXeditable from "../Pages/Forms/FormXeditable";
import FormMask from "../Pages/Forms/FormMask";
import FormElements from "../Pages/Forms/FormElements";
import FormAdvanced from "../Pages/Forms/FormAdvanced";
import FormValidations from "../Pages/Forms/FormValidations";
import FormWizard from "../Pages/Forms/FormWizard";

// Import Tables
import BasicTable from "../Pages/Tables/BasicTable.js";
import ListJs from "../Pages/Tables/ListTables/ListTables";
import DataTable from "../Pages/Tables/DataTables/DataTables";

// Import Charts
import ApexCharts from "../Pages/Charts/ApexCharts";
import ChartJs from "../Pages/Charts/ChartjsCharts";
import Sparklinechart from "../Pages/Charts/SparklineCharts";
import FloatChart from "../Pages/Charts/FloatCharts";
import JknobCharts from "../Pages/Charts/JqueryKnobCharts";

// Import Icon Pages
import IconMaterialdesign from "../Pages/Icons/IconMaterialdesign";
import IconFontawesome from "../Pages/Icons/IconFontAwesome";
import IconDripicons from "../Pages/Icons/IconDrip";
import IconBoxicons from "../Pages/Icons/IconBoxicons";

// Import Map Pages
import VectorMaps from "../Pages/Maps/VectorMap";
import GoogleMap from "../Pages/Maps/GoogleMap";
// import Salesman from "../Pages/Salesman";
// import Orders from "../Pages/Orders";
import Products from "../Pages/Products";
import Brands from "../Pages/Brands/index.js";
import Category from "../Pages/Category/index.js";
import Color from "../Pages/Color/index.js";
import Country from "../Pages/Country";
import State from "../Pages/State";
import City from "../Pages/City";
import Banner from "../Pages/Banner";
import Users from "../Pages/Users/index.js";
import BusinessType from "../Pages/BusinessType/index.js";
import Model from "../Pages/Model/index.js";
import ModelSeries from "../Pages/ModelSeries/index.js";
import Coupons from "../Pages/Coupons/index.js";
import ProductOrder from "../Pages/ProductOrder/index.js";
import Notify from "../Pages/Notify/index.js";
import FAQ from "../Pages/Faq/index.js";
import ActiveCustomers from "../Pages/ActiveCustomers/index.js";
import InactiveCustomers from "../Pages/InactiveCustomers/index.js";
import ToadyActiveCustomers from "../Pages/ToadyActiveCustomers/index.js";
import LastSevenDayCustomers from "../Pages/LastSevenDayCustomers/index.js";
import LastMonthCustomers from "../Pages/LastMonthCustomers/index.js";
import ProductsInactive from "../Pages/ProductsInactive/index.js";
import TodayProducts from "../Pages/TodayProducts/index.js";
import LastSevenDayProducts from "../Pages/LastSevenDayProducts/index.js";
import LastMonthProducts from "../Pages/LastMonthProducts/index.js";
import Package from "../Pages/Package/index.js";
import GlobalBillCode from "../Pages/GlobalBillCode/index.js";
import GlGroup from "../Pages/GlGroup/index.js";
import Bank from "../Pages/Bank/index.js";
import PackageRoles from "../Pages/PackageRoles/index.js";
import PackagePermission from "../Pages/PackagePermision/index.js";
import WhatsNew from "../Pages/WhatsNew/index.js";
import Feedback from "../Pages/Feedback/index.js";
import Index from "../Pages/Global Imei/index.js";
import EwayTransaction from "../Pages/EwayTransaction/index.js";
import PackageTransaction from "../Pages/PackageTransactions/index.js";
import Wallet from "../Pages/Wallet/index.js";
import Items from "../Pages/Items/index.js";
// import Company from "../Pages/Company";

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },

  // Calender
  { path: "/calendar", component: <Calender /> },

  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  // E-mail
  { path: "/inbox", component: <Inbox /> },
  { path: "/read-email", component: <ReadEmail /> },
  { path: "/compose-email", component: <EmailCompose /> },

  // Utility Pages
  { path: "/pages-starter", component: <StarterPage /> },
  { path: "/pages-timeline", component: <TimeLine /> },
  { path: "/pages-faqs", component: <FAQs /> },
  { path: "/pages-pricing", component: <Pricing /> },

  // UiElements Pages
  { path: "/ui-alerts", component: <UiAlerts /> },
  { path: "/ui-badge", component: <UiBadge /> },
  { path: "/ui-breadcrumb", component: <UiBreadcrumb /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModals /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-sessiontimeout", component: <UiSessionTimeout /> },
  { path: "/ui-pagination", component: <UiPagination /> },
  { path: "/ui-progressbars", component: <UiProgressBars /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-tabs-accordions", component: <UiTabs /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-toasts", component: <UiToasts /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-popovers", component: <UiPopovers /> },
  { path: "/ui-rating", component: <UiRating /> },

  // Forms pages
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-validation", component: <FormValidations /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editor", component: <FormEditors /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-editors", component: <FormXeditable /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-mask", component: <FormMask /> },

  // Tables pages
  { path: "/tables-basic", component: <BasicTable /> },
  { path: "/tables-listjs", component: <ListJs /> },
  { path: "/table-datatables", component: <DataTable /> },

  // Charts Pages
  { path: "/chart-apexcharts", component: <ApexCharts /> },
  { path: "/chart-chartjscharts", component: <ChartJs /> },
  { path: "/chart-floatcharts", component: <FloatChart /> },
  { path: "/chart-jknobcharts", component: <JknobCharts /> },
  { path: "/chart-sparklinecharts", component: <Sparklinechart /> },

  // Icons Pages
  { path: "/icon-boxicon", component: <IconBoxicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icon-dripicons", component: <IconDripicons /> },

  // Maps Pages
  { path: "/maps-vector", component: <VectorMaps /> },
  { path: "/maps-google", component: <GoogleMap /> },

  //Default
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  //Salesman
  // {
  //   path: "/salesman",
  //   exact: true,
  //   component: <Salesman />,
  // },
  // {
  //   path: "/company",
  //   exact: true,
  //   component: <Company />,
  // },
  {
    path: "/users",
    exact: true,
    component: <Users />,
  },
  {
    path: "/glGroup",
    exact: true,
    component: <GlGroup />,
  },
  {
    path: "/whats-new",
    exact: true,
    component: <WhatsNew />,
  },
  {
    path: "/bank",
    exact: true,
    component: <Bank />,
  },
  {
    path: "/wallet",
    exact: true,
    component: <Wallet />,
  },
  {
    path: "/items",
    exact: true,
    component: <Items />,
  },
  {
    path: "/packageRole",
    exact: true,
    component: <PackageRoles />,
  },
  {
    path: "/packagePermission",
    exact: true,
    component: <PackagePermission />,
  },
  {
    path: "/packageTransaction",
    exact: true,
    component: <PackageTransaction />,
  },
  {
    path: "/ewayTransaction",
    exact: true,
    component: <EwayTransaction />,
  },
  {
    path: "/businessType",
    exact: true,
    component: <BusinessType />,
  },
  {
    path: "/globalBillCode",
    exact: true,
    component: <GlobalBillCode />,
  },
  {
    path: "/glGroup",
    exact: true,
    component: <GlGroup />,
  },
  {
    path: "/users/active",
    exact: true,
    component: <ActiveCustomers />,
  },
  {
    path: "/users/inactive",
    exact: true,
    component: <InactiveCustomers />,
  },
  {
    path: "/users/today",
    exact: true,
    component: <ToadyActiveCustomers />,
  },
  {
    path: "/users/last7Days",
    exact: true,
    component: <LastSevenDayCustomers />,
  },
  {
    path: "/users/lastMonth",
    exact: true,
    component: <LastMonthCustomers />,
  },
  {
    path: "/products",
    exact: true,
    component: <Products />,
  },
  {
    path: "/products/inactive",
    exact: true,
    component: <ProductsInactive />,
  },
  {
    path: "/products/today",
    exact: true,
    component: <TodayProducts />,
  },
  {
    path: "/products/last7Days",
    exact: true,
    component: <LastSevenDayProducts />,
  },
  {
    path: "/products/lastMonth",
    exact: true,
    component: <LastMonthProducts />,
  },
  {
    path: "/coupons",
    exact: true,
    component: <Coupons />,
  },
  {
    path: "/prodorders",
    exact: true,
    component: <ProductOrder />,
  },
  {
    path: "/notify",
    exact: true,
    component: <Notify />,
  },
  {
    path: "/model",
    exact: true,
    component: <Model />,
  },
  {
    path: "/brand",
    exact: true,
    component: <Brands />,
  },
  {
    path: "/category",
    exact: true,
    component: <Category />,
  },
  {
    path: "/series",
    exact: true,
    component: <ModelSeries />,
  },
  {
    path: "/color",
    exact: true,
    component: <Color />,
  },
  {
    path: "/country",
    exact: true,
    component: <Country />,
  },
  {
    path: "/state",
    exact: true,
    component: <State />,
  },
  {
    path: "/city",
    exact: true,
    component: <City />,
  },
  {
    path: "/package",
    exact: true,
    component: <Package />,
  },
  {
    path: "/banner",
    exact: true,
    component: <Banner />,
  },
  {
    path: "/faq",
    exact: true,
    component: <FAQ />,
  },
  {
    path: "/feedback",
    exact: true,
    component: <Feedback />,
  },
  {
    path: "/settings",
    exact: true,
    component: <UserProfile />,
  },
  {
    path: "/globaliemi",
    exact: true,
    component: <Index />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  // Authentication Inner Pages
  { path: "/auth-login", component: <Login1 /> },
  { path: "/auth-register", component: <Register1 /> },
  { path: "/auth-recoverpw", component: <RecoverPassword /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },

  // Utility Pages
  { path: "/pages-404", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes };
